<form class="vl-form" @submit="onSubmit" autocomplete="off" v-if="isMounted">

    <!-- over-de-werken -->
    <vl-region mod-no-space-top>
        <vl-layout>
            <vl-form-grid mod-stacked>
                <kl-form-row>
                    <vl-column>
                        <vl-title tag-name="h2">Over de werken</vl-title>
                    </vl-column>
                </kl-form-row>

                <kl-form-row>
                    <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                        <kl-field-validation-wrapper-yup for="excavation-type" :field="fields.excavationType"
                                                         v-slot="{ hasErrors }" mod-required>
                            <vl-select name="aard van de werken" id="excavation-type" v-model="excavationType"
                                       :mod-error="hasErrors" mod-block placeholderText="Selecteer een optie">
                                <option :value="key" v-for="(value, key) in viewModel.excavationTypes" :key="'excavationType-' + key">
                                    {{ value }}
                                </option>
                            </vl-select>
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                </kl-form-row>

                <kl-form-row>
                    <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                        <kl-field-validation-wrapper-yup for="excavation-method" :field="fields.excavationMethod"
                                                         v-slot="{hasErrors}" mod-required>
                            <vl-select name="geplande uitvoeringsmethode" id="excavation-method"
                                       v-model="excavationMethod" :mod-error="hasErrors" mod-block
                                       placeholderText="Selecteer een optie">
                                <option :value="key" v-for="(value, key) in viewModel.excavationMethods" :key="'excavationMethod-' + key">
                                    {{ value }}
                                </option>
                            </vl-select>
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                </kl-form-row>

                <kl-form-row>
                    <vl-column :width="fieldWidthHalf" :width-xs="fieldWidthXS" :width-s="fieldWidthHalfS">
                        <kl-field-validation-wrapper-yup for="start-date" :field="fields.startDate"
                                                         v-slot="{hasErrors}" mod-required>
                            <kl-datepicker name="startdatum" id="start-date"
                                           :min-date="startDateMinDate"
                                           v-model="startDate"
                                           :mod-error="hasErrors" />
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                    <vl-column :width="fieldWidthHalf" :width-xs="fieldWidthXS" :width-s="fieldWidthHalfS">
                        <kl-field-validation-wrapper-yup for="end-date" :field="fields.endDate" v-slot="{hasErrors}"
                                                         mod-required>
                            <kl-datepicker name="einddatum" id="end-date"
                                           :min-date="endDateMinDate"
                                           v-model="endDate"
                                           :mod-error="hasErrors" />
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                </kl-form-row>

                <kl-form-row v-if="showPeriodMessage">
                    <vl-column>
                        <vl-typography>
                            <p>
                                <strong>Let op!</strong> U mag pas starten met de werken als alle beheerders hebben
                                geantwoord.<br> Leidingbeheerders hebben tot 5 werkdagen om te antwoorden.
                                Beheerders van leidingen voor het transport van gas, chemicaliën en elektriciteit
                                tot 13 werkdagen.
                            </p>
                        </vl-typography>
                    </vl-column>
                </kl-form-row>

                <kl-form-row>
                    <vl-column :width="fieldWidthHalf" :width-xs="fieldWidthXS" :width-s="fieldWidthHalfS">
                        <kl-field-validation-wrapper-yup for="excavation-depth" :field="fields.excavationDepth"
                                                         v-slot="{hasErrors}" mod-no-wrap-error>
                            <vl-input-group>
                                <vl-input-field type="number" name="graafdiepte" id="excavation-depth" mod-block
                                                v-model="excavationDepth" :mod-error="hasErrors" autocomplete="on" />
                                <vl-input-addon tooltip="In centimeter" text="cm" />
                            </vl-input-group>
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                </kl-form-row>

                <kl-form-row v-if="canOrderImkl">
                    <vl-column>
                        <vl-checkbox name="imkl" id="imkl" v-model="includeImkl">
                            Ik wil ook het IMKL-pakket voor deze planaanvraag
                            <template v-if="viewModel && viewModel.imklPrice">
                                ({{formatCurrency(viewModel.imklPrice) }} {{ applyVat ? ' excl. btw' : '' }} extra per aanvraag)
                            </template>
                        </vl-checkbox>
                    </vl-column>
                </kl-form-row>
            </vl-form-grid>
        </vl-layout>
    </vl-region>
    <!-- ./over-de-werken -->

    <!-- uw-referenties -->
    <vl-region>
        <vl-layout>
            <vl-form-grid mod-stacked>
                <kl-form-row>
                    <vl-column>
                        <vl-title tag-name="h2">Uw referenties</vl-title>
                        <vl-typography>
                            <p>Deze gegevens mag u vrij kiezen en kan u gebruiken om uw planaanvraag later
                                gemakkelijk terug te vinden.</p>
                        </vl-typography>
                    </vl-column>
                </kl-form-row>
                <kl-form-row>
                    <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                        <kl-field-validation-wrapper-yup for="your-reference" :field="fields.reference"
                                                         v-slot="{hasErrors}" mod-required>
                            <vl-input-field name="referentie" id="your-reference" v-model="reference"
                                            :mod-error="hasErrors" mod-block />
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                </kl-form-row>
                <kl-form-row>
                    <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                        <kl-field-validation-wrapper-yup for="excavation-location"
                                                         :field="fields.excavationLocation" v-slot="{hasErrors}">
                            <vl-input-field name="locatie werken" id="excavation-location"
                                            v-model="excavationLocation" :mod-error="hasErrors" mod-block autocomplete="on" />
                        </kl-field-validation-wrapper-yup>
                </vl-column>
                </kl-form-row>
                <kl-form-row>
                    <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                        <kl-field-validation-wrapper-yup for="excavation-description"
                                                         :field="fields.excavationDescription" v-slot="{hasErrors}"
                                                         :mod-required="excavationDescriptionRequired">
                            <vl-input-field name="omschrijving werken" id="excavation-description"
                                            v-model="excavationDescription" :mod-error="hasErrors" mod-block
                                            autocomplete="on" />
                        </kl-field-validation-wrapper-yup>
                    </vl-column>
                </kl-form-row>
                <kl-form-row v-if="excavationDescriptionRequired">
                    <vl-column>
                        <vl-typography>
                            <p>
                                <strong>Let op! </strong>{{excavationDescriptionWarning}}
                            </p>
                        </vl-typography>
                    </vl-column>
                </kl-form-row>
                <kl-form-row>
                    <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                        <kl-tags v-model="tags" placeholder="Tags toevoegen"
                                 annotation="Deze tags kan u later nog bewerken." :form-path="fields.tags.path" />
                    </vl-column>
                </kl-form-row>
            </vl-form-grid>
        </vl-layout>
    </vl-region>
    <!-- ./uw-referenties -->

    <!-- uw-contactgegevens -->
    <vl-region>
        <vl-layout>
            <vl-form-grid mod-stacked>
                <kl-form-row>
                    <vl-column>
                        <vl-title tag-name="h2">Uw gegevens</vl-title>
                        <vl-typography>
                            <p>
                                Leidingbeheerders hebben uw contactgegevens nodig om u te kunnen contacteren bij problemen.
                            </p>
                        </vl-typography>
                    </vl-column>
                </kl-form-row>

                <!-- uw-organisaties -->
                <kl-form-row v-if="showOrgDropDown">
                    <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                        <kl-field-validation-wrapper-yup for="organisation" :field="fields.organisationId"
                                                         v-slot="{hasErrors}" mod-required>
                            <vl-select name="organisatie" id="organisation" v-model="organisationId"
                                       :mod-error="hasErrors" mod-block placeholderText="Selecteer een optie">
                                <option :value="item.key" v-for="(item, index) in viewModel.subOrganisations"
                                        :key="'organisation-' + item.key">
                                    <span v-html="setDepth(item.order, item.label)"></span>
                                </option>
                            </vl-select>
                        </kl-field-validation-wrapper-yup>
                        <vl-u-spacer />
                    </vl-column>
                </kl-form-row>
                <!-- ./uw-organisaties -->

                <!-- contact details -->
                <kl-form-row v-if="showContactCard">
                    <vl-column>
                        <kl-contact-card :title="contactDetails.name" :subtitle="contactRole"
                                         :phone="contactDetails.telephone" :email="contactDetails.email"
                                         :address="contactAddress" />
                        <vl-u-spacer mod-small />
                        <vl-button type="button" @click="editContactDetails" mod-link>
                            Wijzig contactgegevens
                        </vl-button>
                    </vl-column>
                </kl-form-row>
                <!-- ./contact details -->

                <!-- edit contact details -->
                <template v-if="!showContactCard">
                    <kl-form-row>
                        <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                            <kl-field-validation-wrapper-yup for="role" :field="fields.role" v-slot="{hasErrors}"
                                                             mod-required>
                                <vl-select name="rol" id="role" v-model="role" :mod-error="hasErrors" mod-block
                                           placeholderText="Selecteer een optie">
                                    <option :value="mapRequestRole.key" v-for="mapRequestRole in mapRequestRoles" :key="'role-' + mapRequestRole.key">
                                        {{ mapRequestRole.value }}
                                    </option>
                                </vl-select>
                            </kl-field-validation-wrapper-yup>
                            <vl-u-spacer />
                        </vl-column>
                    </kl-form-row>
                    <kl-form-row v-if="!user.isCitizen">
                        <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                            <kl-field-validation-wrapper-yup for="address-additional-line" name="Gebouw"
                                                             :field="fields.addressAdditionalLine" v-slot="{hasErrors}">
                                <vl-input-field name="gebouw" id="address-additional-line"
                                                v-model="addressAdditionalLine" :mod-error="hasErrors" mod-block
                                                autocomplete="on" />
                            </kl-field-validation-wrapper-yup>
                        </vl-column>
                    </kl-form-row>
                    <kl-form-row>
                        <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                            <kl-address-form v-model="address" :form-path="fields.address.path" />
                            <vl-u-spacer />
                        </vl-column>
                    </kl-form-row>
                    <kl-form-row>
                        <vl-column :width="fieldWidthHalf" :width-xs="fieldWidthXS" :width-s="fieldWidthHalfS">
                            <kl-field-validation-wrapper-yup for="telefoon" name="Telefoon"
                                                             :field="fields.telephone" v-slot="{hasErrors}" mod-required>
                                <vl-input-field name="telefoon" id="telefoon" placeholder="+32" v-model="telephone"
                                                :mod-error="hasErrors" mod-block autocomplete="on" />
                            </kl-field-validation-wrapper-yup>
                            <vl-u-spacer />
                        </vl-column>
                    </kl-form-row>

                    <kl-form-row v-if="userHasNoEmail">
                        <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS">
                            <kl-field-validation-wrapper-yup for="email-address" :field="fields.emailAddress"
                                                             v-slot="{hasErrors}" mod-required>
                                <vl-input-field name="e-mailadres" id="email-address" v-model="emailAddress"
                                                autocomplete="on" placeholder="E-mail" :mod-error="hasErrors" mod-block />
                            </kl-field-validation-wrapper-yup>
                        </vl-column>
                    </kl-form-row>
                    <template v-if="!userHasNoEmail">
                        <kl-form-row>
                            <vl-column>
                                <vl-form-message-label>E-mail vanuit uw profiel:</vl-form-message-label>
                                {{ user.email }}
                            </vl-column>
                            <vl-column>
                                <vl-checkbox name="use-alternative-email" id="use-alternative-email"
                                             v-model="useAlternativeEmail">
                                    Stuur meldingen naar een ander e-mailadres
                                </vl-checkbox>
                            </vl-column>
                        </kl-form-row>
                        <kl-form-row>
                            <vl-column :width="fieldWidth" :width-xs="fieldWidthXS" :width-s="fieldWidthS" v-if="useAlternativeEmail">
                                <kl-field-validation-wrapper-yup for="alternate-email-address"
                                                                 :field="fields.alternateEmailAddress" v-slot="{hasErrors}" mod-required
                                                                 mod-hidden-label>
                                    <vl-input-field name="e-mailadres" id="alternate-email-address"
                                                    v-model="alternateEmailAddress" autocomplete="on" placeholder="E-mail"
                                                    :mod-error="hasErrors" mod-block />
                                </kl-field-validation-wrapper-yup>
                            </vl-column>
                        </kl-form-row>
                    </template>

                    <kl-form-row>
                        <vl-u-spacer mod-small />
                    </kl-form-row>

                    <kl-form-row>
                        <vl-column>
                            <vl-checkbox v-model="rememberContactDetails" mod-switch>
                                Onthoud mijn contactgegevens voor volgende planaanvragen
                            </vl-checkbox>
                        </vl-column>
                    </kl-form-row>
                </template>
                <!-- ./edit contact details -->

            </vl-form-grid>
        </vl-layout>
    </vl-region>
    <!-- ./uw-contactgegevens -->

    <!-- form-actions -->
    <vl-region>
        <vl-layout>
            <vl-button type="submit" ref="goToStep3" mod-large>Volgende</vl-button>
            <ippro-icon-text v-if="showStep2ValidationInfo" icon="alert-circle" v-vl-text.error>
                Vul alle verplichte velden in en probeer opnieuw
            </ippro-icon-text>
        </vl-layout>
    </vl-region>
    <!-- ./form-actions -->

</form>
